import { useEffect, useMemo, useState } from "react";
import { useGetLobbyBannersQuery } from "../../../store/service/lobbyBannerService";
import { APP_BRAND_MARK, APP_BRAND_TAIL } from "../../../utils/brand";
import {
  FEATURED_EVENTS,
  LobbySportIcon,
  QUICK_TAB_ITEMS,
  SPORT_STRIP_ITEMS,
} from "../../pages/client/lobbySportIcons";
import "../../pages/client/Client.scss";

const LOBBY_IMG = "/Images/lobby";

const FALLBACK_BANNERS = [
  `${LOBBY_IMG}/1784145560718.webp`,
  `${LOBBY_IMG}/1784175872234.webp`,
];

const FALLBACK_TRENDING = [
  { imageUrl: `${LOBBY_IMG}/1778317315739.webp`, altText: "Super Over 2" },
  { imageUrl: `${LOBBY_IMG}/1778317145379.webp`, altText: "Andar Bahar" },
];

const FALLBACK_CASINO = [
  { imageUrl: `${LOBBY_IMG}/1778317091657.webp`, altText: "Mini Super Over" },
  { imageUrl: `${LOBBY_IMG}/1778317109540.webp`, altText: "Unique Roulette" },
];

const FALLBACK_NEW_GAMES = [
  { imageUrl: `${LOBBY_IMG}/1778317073097.webp`, altText: "Pilot Chicken" },
  { imageUrl: `${LOBBY_IMG}/1778318146775.webp`, altText: "JetX" },
];

const MENU_SPORTS = [
  "Cricket(20)",
  "Football(94)",
  "Tennis(125)",
  "Table Tennis(184)",
  "Badminton(9)",
  "Esoccer(24)",
];

const WINNERS = [
  { name: "Kd*****", amount: "1,22,15,000", time: "15/07/2026 10:36" },
  { name: "Ma*****", amount: "1,17,20,500", time: "15/07/2026 10:31" },
  { name: "ma****", amount: "1,00,27,500", time: "15/07/2026 10:24" },
];

const PreLoginLobby = ({
  loginOpen,
  onOpenLogin,
  onCloseLogin,
  loginModal,
  footer,
}) => {
  const { data: lobbyData } = useGetLobbyBannersQuery();
  const [menuOpen, setMenuOpen] = useState(false);
  const [bannerIdx, setBannerIdx] = useState(0);
  const [activeSport, setActiveSport] = useState("Cricket");

  const lobby = lobbyData?.data || {};

  const banners = useMemo(() => {
    const rows = lobby.banner || [];
    if (!rows.length) return FALLBACK_BANNERS;
    return rows.map((row) => row.imageUrl);
  }, [lobby.banner]);

  const trendingCards = lobby.trending?.length ? lobby.trending : FALLBACK_TRENDING;
  const casinoCards = lobby.casino?.length ? lobby.casino : FALLBACK_CASINO;
  const newGameCards = lobby.new_games?.length ? lobby.new_games : FALLBACK_NEW_GAMES;

  useEffect(() => {
    setBannerIdx(0);
  }, [banners.length]);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const timer = setInterval(() => {
      setBannerIdx((idx) => (idx + 1) % banners.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [banners.length]);

  const renderCards = (cards) =>
    cards.map((card) => (
      <article
        key={`${card.id || card.altText}-${card.imageUrl}`}
        className="w777-card w777-card-img"
        style={{ backgroundImage: `url(${card.imageUrl})` }}
        aria-label={card.altText}
      />
    ));

  return (
    <div className="w777-login-page">
      {menuOpen ? <button className="w777-drawer-backdrop" onClick={() => setMenuOpen(false)} /> : null}
      <aside className={`w777-side-drawer ${menuOpen ? "open" : ""}`}>
        <div className="w777-side-head">
          <h3>
            {APP_BRAND_MARK} <small>{APP_BRAND_TAIL}</small>
          </h3>
        </div>
        <div className="w777-side-list">
          {MENU_SPORTS.map((s) => (
            <button key={s} type="button" onClick={() => setMenuOpen(false)}>
              {s}
            </button>
          ))}
        </div>
      </aside>

      <header className="w777-login-header">
        <button
          type="button"
          className="w777-login-menu"
          aria-label="Menu"
          onClick={() => setMenuOpen((v) => !v)}>
          <span />
          <span />
          <span />
        </button>
        <h1 className="w777-login-logo">
          <span className="w777-logo-mark">{APP_BRAND_MARK}</span>
          <span className="w777-logo-tail">{APP_BRAND_TAIL}</span>
        </h1>
        <button type="button" className="w777-login-top-btn" onClick={onOpenLogin}>
          LOGIN
        </button>
      </header>

      <div className="w777-login-ticker">
        <img src={`${LOBBY_IMG}/speaker.svg`} alt="" className="w777-ticker-icon" />
        <span>Real-Time Odds · Live Casino · Instant Settlement</span>
      </div>

      <main className="w777-lobby">
        <section className="w777-featured-scroll">
          {FEATURED_EVENTS.map((event) => (
            <button key={event.label} type="button" className={`w777-featured-chip ${event.tone}`}>
              <LobbySportIcon name={event.icon} className="w777-featured-icon" />
              <span>{event.label}</span>
            </button>
          ))}
        </section>

        <section className="w777-banner-wrap">
          <div
            className="w777-banner"
            style={{ backgroundImage: `url(${banners[bannerIdx]})` }}
            role="img"
            aria-label="Promotional banner"
          />
          <div className="w777-banner-dots">
            {banners.map((src, idx) => (
              <button
                key={src}
                type="button"
                className={idx === bannerIdx ? "active" : ""}
                aria-label={`Go to banner ${idx + 1}`}
                onClick={() => setBannerIdx(idx)}
              />
            ))}
          </div>
        </section>

        <section className="w777-section">
          <h4>Now Trending</h4>
          <div className="w777-slider w777-slider-scroll">{renderCards(trendingCards)}</div>
        </section>

        <section className="w777-quick-tabs">
          {QUICK_TAB_ITEMS.map((tab) => (
            <button key={tab.label} type="button" className="w777-quick-tab-btn">
              <LobbySportIcon name={tab.icon} className="w777-tab-icon" />
              <span>{tab.label}</span>
            </button>
          ))}
        </section>

        <section className="w777-sports-strip">
          {SPORT_STRIP_ITEMS.map((sport) => (
            <button
              key={sport.label}
              type="button"
              className={sport.label === activeSport ? "active" : ""}
              onClick={() => setActiveSport(sport.label)}>
              <LobbySportIcon name={sport.icon} className="w777-sport-icon" />
              <span>{sport.label}</span>
            </button>
          ))}
        </section>

        <div className="w777-empty-row">no records found</div>

        <section className="w777-section">
          <h4>Our Casino</h4>
          <div className="w777-slider w777-slider-scroll">{renderCards(casinoCards)}</div>
        </section>

        <section className="w777-section">
          <h4>New Games</h4>
          <div className="w777-slider w777-slider-scroll">{renderCards(newGameCards)}</div>
        </section>

        <section className="w777-section">
          <h4>Winner Announcement</h4>
          <div className="w777-winner-list">
            {WINNERS.map((w) => (
              <div className="w777-winner-row" key={w.name + w.time}>
                <div>
                  <strong>{w.name}</strong>
                  <p>{w.time}</p>
                </div>
                <span>{w.amount}</span>
              </div>
            ))}
          </div>
        </section>

        {footer ? <div className="w777-lobby-footer">{footer}</div> : null}
      </main>

      {loginOpen ? (
        <div className="w777-login-modal-wrap" onMouseDown={onCloseLogin}>
          <div onMouseDown={(e) => e.stopPropagation()}>{loginModal}</div>
        </div>
      ) : null}
    </div>
  );
};

export default PreLoginLobby;
